(function(){
  // The shipping policy's own rich-text content (edited in Shopify Admin)
  // already opens with a branded EWOOWE + "Shipping policy" image, making
  // Shopify's own default .shopify-policy__title heading directly above it
  // redundant — hidden only on this one policy page, since other policies
  // (Refund, Privacy, ...) don't have that image and still need their
  // heading.
  if (location.pathname === '/policies/shipping-policy') {
    const title = document.querySelector('.shopify-policy__title');
    if (title) title.style.display = 'none';
  }

  const drawer = document.getElementById('EwooweCartDrawer');
  const mobile = document.querySelector('[data-mobile-menu]');
  const quickAddModal = document.getElementById('QuickAddModal');
  const quickAddModalBody = quickAddModal?.querySelector('[data-quick-add-modal-body]');
  function setDrawer(open){ if(!drawer)return; drawer.classList.toggle('is-open',open); drawer.setAttribute('aria-hidden',String(!open)); }

  const searchOverlay = document.getElementById('SearchOverlay');
  const searchInput = document.getElementById('SearchOverlayInput');
  const searchResults = searchOverlay?.querySelector('[data-search-results]');
  const searchPopular = searchOverlay?.querySelector('[data-search-popular]');
  const searchLink = document.querySelector('[data-search-open]');

  if (searchOverlay && searchInput && searchResults) {
    let searchRequestId = 0;

    function debounce(fn, delay){
      let timer;
      return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), delay); };
    }

    async function runSearch(query){
      const requestId = ++searchRequestId;
      if (!query) {
        searchResults.innerHTML = '';
        searchPopular?.removeAttribute('hidden');
        return;
      }
      searchPopular?.setAttribute('hidden', '');
      searchResults.innerHTML = '<p class="search-overlay__loading">Searching…</p>';
      try {
        const searchUrl = searchLink?.getAttribute('href') || '/search';
        const res = await fetch(`${searchUrl}?q=${encodeURIComponent(query)}&type=product&section_id=main-search`);
        if (requestId !== searchRequestId) return;
        const html = await res.text();
        if (requestId !== searchRequestId) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('.product-grid');
        const empty = doc.querySelector('.search-empty');
        const count = doc.querySelector('.search-count');
        let out = '';
        if (count) out += count.outerHTML;
        out += grid ? grid.outerHTML : (empty ? empty.outerHTML : '');
        searchResults.innerHTML = out;
      } catch (err) {
        if (requestId === searchRequestId) searchResults.innerHTML = '';
      }
    }

    const debouncedSearch = debounce(runSearch, 300);

    searchInput.addEventListener('input', () => { debouncedSearch(searchInput.value.trim()); });

    searchInput.addEventListener('keydown', e => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      const query = searchInput.value.trim();
      if (!query) return;
      const searchUrl = searchLink?.getAttribute('href') || '/search';
      location.href = `${searchUrl}?q=${encodeURIComponent(query)}`;
    });
  }

  function openSearch(){
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    searchInput?.focus();
  }

  function closeSearch(){
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    searchPopular?.removeAttribute('hidden');
  }

  const drawerPanel = drawer?.querySelector('.drawer__panel');
  const drawerBackdrop = drawer?.querySelector('.drawer__backdrop');

  if (drawerPanel && drawerBackdrop) {
    const SWIPE_MOBILE_MAX_WIDTH = 900;
    const SWIPE_COMMIT_DISTANCE_RATIO = .35;
    const SWIPE_COMMIT_VELOCITY = .5;
    const SWIPE_DIRECTION_LOCK = 10;
    const SWIPE_EDGE_ZONE_PX = 24;

    let touchId = null;
    let startX = 0, startY = 0, startTime = 0;
    let dragX = 0;
    let direction = null;
    let panelWidth = 0;

    function swipeTouch(e){
      for (const t of e.changedTouches) if (t.identifier === touchId) return t;
      return null;
    }

    function onDrawerTouchStart(e){
      if (touchId !== null) return;
      if (!drawer.classList.contains('is-open') || window.innerWidth > SWIPE_MOBILE_MAX_WIDTH) return;
      const touch = e.changedTouches[0];
      touchId = touch.identifier;
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = Date.now();
      dragX = 0;
      direction = null;
      panelWidth = drawerPanel.getBoundingClientRect().width;
    }

    function onDrawerTouchMove(e){
      if (touchId === null) return;
      const touch = swipeTouch(e);
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;

      if (direction === null) {
        if (Math.abs(dx) < SWIPE_DIRECTION_LOCK && Math.abs(dy) < SWIPE_DIRECTION_LOCK) return;
        if (Math.abs(dx) > Math.abs(dy) && dx > 0) {
          direction = 'horizontal';
          drawerPanel.style.transition = 'none';
          drawerBackdrop.style.transition = 'none';
        } else {
          direction = 'vertical';
          touchId = null;
          return;
        }
      }
      if (direction !== 'horizontal') return;

      e.preventDefault();
      dragX = Math.max(0, dx);
      drawerPanel.style.transform = `translateX(${dragX}px)`;
      drawerBackdrop.style.opacity = String(Math.max(0, 1 - dragX / panelWidth));
    }

    function onDrawerTouchEnd(){
      if (touchId === null) { direction = null; return; }
      const wasHorizontal = direction === 'horizontal';
      touchId = null;
      direction = null;
      if (!wasHorizontal) return;

      const elapsed = Math.max(1, Date.now() - startTime);
      const velocity = dragX / elapsed;
      const shouldClose = dragX > panelWidth * SWIPE_COMMIT_DISTANCE_RATIO || velocity > SWIPE_COMMIT_VELOCITY;

      drawerPanel.style.transition = '';
      drawerBackdrop.style.transition = '';
      drawerPanel.style.transform = '';
      drawerBackdrop.style.opacity = '';
      if (shouldClose) setDrawer(false);
    }

    drawerPanel.addEventListener('touchstart', onDrawerTouchStart, { passive: true });
    drawerPanel.addEventListener('touchmove', onDrawerTouchMove, { passive: false });
    drawerPanel.addEventListener('touchend', onDrawerTouchEnd, { passive: true });
    drawerPanel.addEventListener('touchcancel', onDrawerTouchEnd, { passive: true });

    let edgeTouchId = null;
    let edgeStartX = 0, edgeStartY = 0, edgeStartTime = 0;
    let edgeDragX = 0;
    let edgeDirection = null;
    let edgePanelWidth = 0;

    function edgeSwipeTouch(e){
      for (const t of e.changedTouches) if (t.identifier === edgeTouchId) return t;
      return null;
    }

    function onEdgeTouchStart(e){
      if (edgeTouchId !== null) return;
      if (drawer.classList.contains('is-open') || window.innerWidth > SWIPE_MOBILE_MAX_WIDTH) return;
      if (mobile?.classList.contains('is-open')) return;
      if (quickAddModal?.classList.contains('is-open')) return;
      const touch = e.changedTouches[0];
      if (touch.clientX < window.innerWidth - SWIPE_EDGE_ZONE_PX) return;
      edgeTouchId = touch.identifier;
      edgeStartX = touch.clientX;
      edgeStartY = touch.clientY;
      edgeStartTime = Date.now();
      edgeDragX = 0;
      edgeDirection = null;
      edgePanelWidth = Math.min(430, window.innerWidth);
    }

    function onEdgeTouchMove(e){
      if (edgeTouchId === null) return;
      const touch = edgeSwipeTouch(e);
      if (!touch) return;
      const dx = touch.clientX - edgeStartX;
      const dy = touch.clientY - edgeStartY;

      if (edgeDirection === null) {
        if (Math.abs(dx) < SWIPE_DIRECTION_LOCK && Math.abs(dy) < SWIPE_DIRECTION_LOCK) return;
        if (Math.abs(dx) > Math.abs(dy) && dx < 0) {
          edgeDirection = 'horizontal';
          drawerPanel.style.transition = 'none';
          drawerBackdrop.style.transition = 'none';
        } else {
          edgeDirection = 'vertical';
          edgeTouchId = null;
          return;
        }
      }
      if (edgeDirection !== 'horizontal') return;

      e.preventDefault();
      edgeDragX = Math.min(edgePanelWidth, Math.max(0, -dx));
      drawerPanel.style.transform = `translateX(${edgePanelWidth - edgeDragX}px)`;
      drawerBackdrop.style.opacity = String(Math.min(1, edgeDragX / edgePanelWidth));
    }

    function onEdgeTouchEnd(){
      if (edgeTouchId === null) { edgeDirection = null; return; }
      const wasHorizontal = edgeDirection === 'horizontal';
      edgeTouchId = null;
      edgeDirection = null;
      if (!wasHorizontal) return;

      const elapsed = Math.max(1, Date.now() - edgeStartTime);
      const velocity = edgeDragX / elapsed;
      const shouldOpen = edgeDragX > edgePanelWidth * SWIPE_COMMIT_DISTANCE_RATIO || velocity > SWIPE_COMMIT_VELOCITY;

      drawerPanel.style.transition = '';
      drawerBackdrop.style.transition = '';
      drawerPanel.style.transform = '';
      drawerBackdrop.style.opacity = '';
      if (shouldOpen) setDrawer(true);
    }

    document.addEventListener('touchstart', onEdgeTouchStart, { passive: true });
    document.addEventListener('touchmove', onEdgeTouchMove, { passive: false });
    document.addEventListener('touchend', onEdgeTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onEdgeTouchEnd, { passive: true });
  }

  const filterForm = document.getElementById('CollectionFilterForm');
  const sidebar = document.getElementById('CollectionSidebar');
  const backdrop = document.querySelector('.filter-drawer-backdrop');
  const grid = document.getElementById('CollectionProductGrid');
  const toolbar = document.querySelector('.collection-toolbar');
  const count = document.getElementById('CollectionCount');

  function openDrawer(){ sidebar?.classList.add('is-open'); backdrop?.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ sidebar?.classList.remove('is-open'); backdrop?.classList.remove('is-open'); document.body.style.overflow=''; }

  function swapCollection(html){
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSidebar = doc.getElementById('CollectionSidebar');
    const newGrid = doc.getElementById('CollectionProductGrid');
    const newToolbar = doc.querySelector('.collection-toolbar');
    const newCount = doc.getElementById('CollectionCount');
    if (newSidebar && sidebar) sidebar.innerHTML = newSidebar.innerHTML;
    if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
    if (newToolbar && toolbar) toolbar.innerHTML = newToolbar.innerHTML;
    if (newCount && count) count.textContent = newCount.textContent;
  }

  let loadRequestId = 0;
  async function loadCollection(url, push){
    const requestId = ++loadRequestId;
    if (grid) grid.style.opacity = '.5';
    try {
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(url + sep + 'section_id=main-collection');
      if (requestId !== loadRequestId) return;
      if (!res.ok) { window.location.href = url; return; }
      const html = await res.text();
      if (requestId !== loadRequestId) return;
      swapCollection(html);
      if (push) history.pushState({ ewooweCollection: true }, '', url);
    } catch (err) {
      if (requestId === loadRequestId) window.location.href = url;
    } finally {
      if (requestId === loadRequestId && grid) grid.style.opacity = '';
    }
  }

  function currentFilterUrl(){
    const liveForm = document.getElementById('CollectionFilterForm');
    const params = new URLSearchParams(new FormData(liveForm));
    const clean = new URLSearchParams();
    params.forEach((v,k)=>{ if (v) clean.append(k,v); });
    const qs = clean.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  if (filterForm) {
    document.addEventListener('change', e=>{
      const t = e.target;
      if (t.matches('[data-sort-select]') || (t.closest('#CollectionFilterForm') && t.matches('input'))) {
        loadCollection(currentFilterUrl(), true);
      }
    });

    document.addEventListener('submit', e=>{
      if (e.target.id === 'CollectionFilterForm') {
        e.preventDefault();
        loadCollection(currentFilterUrl(), true);
      }
    });

    window.addEventListener('popstate', ()=>{ loadCollection(window.location.href, false); });
  }

  document.addEventListener('click', e=>{
    const t=e.target;
    if(t.closest('[data-drawer-close]')) setDrawer(false);
    if(t.closest('.bag-link')) { e.preventDefault(); setDrawer(true); }
    if(t.closest('[data-search-open]')) {
      e.preventDefault();
      if (searchOverlay?.classList.contains('is-open')) closeSearch(); else openSearch();
    }
    if(t.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
    const searchPill = t.closest('[data-search-pill]');
    if (searchPill && searchInput) {
      const term = searchPill.getAttribute('data-search-pill');
      searchInput.value = term;
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus();
    }
    if(t.closest('[data-mobile-open]')) {
      const willOpen = !mobile?.classList.contains('is-open');
      mobile?.classList.toggle('is-open', willOpen);
      mobile?.setAttribute('aria-hidden', String(!willOpen));
      if (!willOpen) document.querySelectorAll('[data-mobile-nav-item].is-open').forEach(el=>el.classList.remove('is-open'));
    } else if (mobile?.classList.contains('is-open') && !t.closest('[data-mobile-menu]')) {
      mobile.classList.remove('is-open');
      mobile.setAttribute('aria-hidden','true');
      document.querySelectorAll('[data-mobile-nav-item].is-open').forEach(el=>el.classList.remove('is-open'));
    }

    const mobileNavToggle = t.closest('[data-mobile-nav-toggle]');
    if (mobileNavToggle) {
      const item = mobileNavToggle.closest('[data-mobile-nav-item]');
      const willOpen = !item.classList.contains('is-open');
      document.querySelectorAll('[data-mobile-nav-item].is-open').forEach(el=>{ if (el !== item) el.classList.remove('is-open'); });
      item.classList.toggle('is-open', willOpen);
    }

    if (!filterForm) return;
    const toggle = t.closest('.filter-group__toggle');
    if (toggle) { toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true')); }
    const removePill = t.closest('[data-filter-remove]');
    if (removePill) { e.preventDefault(); loadCollection(removePill.getAttribute('href'), true); }
    const clearAll = t.closest('.active-filters__clear');
    if (clearAll) { e.preventDefault(); loadCollection(clearAll.getAttribute('href'), true); }
    const pageLink = t.closest('#CollectionProductGrid .pagination__link');
    if (pageLink) { e.preventDefault(); loadCollection(pageLink.getAttribute('href'), true); window.scrollTo({top:0,behavior:'smooth'}); }
    if (t.closest('[data-filter-open]')) openDrawer();
    if (t.closest('[data-filter-close]')) closeDrawer();
  });

  document.querySelectorAll('[data-product-form]').forEach(form=>{
    form.addEventListener('submit', async e=>{
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      const fd=new FormData(form);
      const res=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
      if(!res.ok){form.submit();return;}
      const cart=await fetch('/cart.js').then(r=>r.json());
      updateCartCount(cart.item_count);
      await refreshCartFragments();

      if (submitBtn && submitBtn.id === 'AddToBagBtn') {
        const textEl = document.getElementById('AddToBagBtnText');
        clearTimeout(submitBtn._confirmTimer);
        submitBtn.classList.add('is-added');
        if (textEl) textEl.textContent = 'Added to Bag';
        submitBtn._confirmTimer = setTimeout(()=>{
          submitBtn.classList.remove('is-added');
          if (textEl) textEl.textContent = submitBtn.dataset.label;
        }, 1800);
      }
      if (submitBtn) submitBtn.disabled = false;
    });
  });

  document.addEventListener('mouseover', e=>{
    const swatch = e.target.closest('.swatch[data-hover-image]');
    if (!swatch) return;
    const card = swatch.closest('.product-card');
    const preview = card?.querySelector('.product-card__img--swatch-preview');
    if (!preview) return;
    // Crossfade via a dedicated overlay image instead of hard-swapping the
    // primary image's src, so the color change fades in smoothly.
    if (preview.src !== swatch.dataset.hoverImage) preview.src = swatch.dataset.hoverImage;
    card.classList.add('is-swatch-preview');
  });

  document.addEventListener('mouseout', e=>{
    const swatch = e.target.closest('.swatch[data-hover-image]');
    if (!swatch) return;
    swatch.closest('.product-card')?.classList.remove('is-swatch-preview');
  });

  // Any element carrying data-cart-refresh-target (the /cart page's #CartContent
  // and the drawer's #CartDrawerContent, rendered from the same snippet) gets
  // kept in sync from a single fetch, so editing quantity in either place
  // updates both immediately.
  function cartRefreshTargets(){
    return Array.from(document.querySelectorAll('[data-cart-refresh-target]'));
  }

  async function refreshCartFragments(){
    const targets = cartRefreshTargets();
    targets.forEach(t=>t.style.opacity = '.5');
    try {
      const res = await fetch('/cart?section_id=main-cart');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-cart-refresh-target]');
      if (newContent) targets.forEach(t=>t.innerHTML = newContent.innerHTML);
    } finally {
      targets.forEach(t=>t.style.opacity = '');
    }
  }

  document.addEventListener('change', async e=>{
    const input = e.target.closest('.qty-input[data-line-key]');
    if (!input) return;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: input.dataset.lineKey, quantity: Math.max(0, parseInt(input.value, 10) || 0)})
      });
      if (!res.ok) { input.closest('form')?.submit(); return; }
      const cart = await res.json();
      updateCartCount(cart.item_count);
      await refreshCartFragments();
    } catch (err) {
      input.closest('form')?.submit();
    }
  });

  document.addEventListener('click', async e=>{
    const removeLink = e.target.closest('[data-cart-remove]');
    if (!removeLink) return;
    e.preventDefault();
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: removeLink.dataset.lineKey, quantity: 0})
      });
      if (!res.ok) throw new Error();
      const cart = await res.json();
      updateCartCount(cart.item_count);
      await refreshCartFragments();
    } catch (err) {
      window.location.href = removeLink.href;
    }
  });

  // --- Quick Add: add-to-cart directly from product cards, no navigation ---
  function formatMoney(cents){
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateCartCount(itemCount){
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=itemCount);
    document.querySelectorAll('[data-cart-item-count-text]').forEach(el=>{
      el.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
    });
  }

  function showQuickAddStepper(wrap, key, quantity){
    if (!wrap) return;
    const btn = wrap.querySelector('[data-quick-add-simple], [data-quick-add-open]');
    const stepper = wrap.querySelector('[data-qty-stepper]');
    if (btn) btn.hidden = true;
    if (stepper) {
      stepper.hidden = false;
      stepper.dataset.lineKey = key;
      const val = stepper.querySelector('[data-qty-value]');
      if (val) val.textContent = quantity;
    }
  }

  function showQuickAddButton(wrap){
    if (!wrap) return;
    const btn = wrap.querySelector('[data-quick-add-simple], [data-quick-add-open]');
    const stepper = wrap.querySelector('[data-qty-stepper]');
    if (stepper) stepper.hidden = true;
    if (btn) btn.hidden = false;
  }

  async function quickAddToCart(variantId, quantity){
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: variantId, quantity}]})
    });
    if (!res.ok) {
      const err = await res.json().catch(()=>({}));
      throw new Error(err.description || 'Could not add to bag.');
    }
    const data = await res.json();
    // /cart/add.js only reports the item(s) just added, not the cart total —
    // fetch the real cart for an accurate item_count for the header badge.
    const cart = await fetch('/cart.js').then(r=>r.json());
    data.item_count = cart.item_count;
    await refreshCartFragments();
    return data;
  }

  // Simple (single-variant) products: one click, no picker needed.
  document.addEventListener('click', async e=>{
    const btn = e.target.closest('[data-quick-add-simple]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const wrap = btn.closest('[data-quick-add]');
    btn.disabled = true;
    try {
      const data = await quickAddToCart(btn.dataset.variantId, 1);
      updateCartCount(data.item_count);
      clearTimeout(btn._confirmTimer);
      btn.classList.add('is-added');
      btn._confirmTimer = setTimeout(()=>{
        btn.classList.remove('is-added');
        showQuickAddStepper(wrap, data.items[0].key, data.items[0].quantity);
      }, 1800);
    } catch (err) {
      btn.disabled = false;
    }
  });

  // Card-level quantity stepper for a product already in the cart.
  document.addEventListener('click', async e=>{
    const stepBtn = e.target.closest('[data-quick-add] [data-qty-increase], [data-quick-add] [data-qty-decrease]');
    if (!stepBtn) return;
    e.preventDefault();
    const stepper = stepBtn.closest('[data-qty-stepper]');
    const valueEl = stepper.querySelector('[data-qty-value]');
    const current = parseInt(valueEl.textContent, 10) || 0;
    const next = stepBtn.matches('[data-qty-increase]') ? current + 1 : Math.max(0, current - 1);
    if (next === current) return;
    stepper.querySelectorAll('button').forEach(b=>b.disabled = true);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: stepper.dataset.lineKey, quantity: next})
      });
      if (!res.ok) throw new Error();
      const cart = await res.json();
      updateCartCount(cart.item_count);
      await refreshCartFragments();
      if (next === 0) {
        showQuickAddButton(stepper.closest('[data-quick-add]'));
      } else {
        valueEl.textContent = next;
      }
    } catch (err) {
      // leave the displayed value as-is; nothing changed server-side
    } finally {
      stepper.querySelectorAll('button').forEach(b=>b.disabled = false);
    }
  });

  // Products with real variants (Color/Size/...): open a picker modal instead
  // of guessing which variant to add.
  let quickAddProduct = null;
  let quickAddSourceWrap = null;

  function quickAddCurrentVariant(){
    if (!quickAddProduct || !quickAddModalBody) return null;
    const selected = quickAddProduct.options.map((_, idx) => {
      const checked = quickAddModalBody.querySelector(`input[name="quick-add-option-${idx}"]:checked`);
      return checked ? checked.value : null;
    });
    return quickAddProduct.variants.find(v => v.options.every((val, i) => val === selected[i]));
  }

  function quickAddColorOptionIndex(){
    return quickAddProduct ? quickAddProduct.options.findIndex(o => /colou?r/i.test(o.name)) : -1;
  }

  // Swaps the modal's preview photo to match whichever color is currently
  // selected, using that color's own variant image (same variant->image
  // matching pattern as the product-card swatches and the PDP color sync) —
  // mirrors what the cart line already shows correctly after adding, so the
  // customer sees the right photo *before* adding, not just after.
  function quickAddUpdateImage(){
    const imgEl = quickAddModalBody.querySelector('[data-quick-add-modal-image]');
    const colorIdx = quickAddColorOptionIndex();
    if (!imgEl || colorIdx === -1) return;
    const checked = quickAddModalBody.querySelector(`input[name="quick-add-option-${colorIdx}"]:checked`);
    if (!checked) return;
    const match = quickAddProduct.variants.find(v => v.options[colorIdx] === checked.value && v.featured_image);
    if (!match) return;
    const src = match.featured_image.src;
    imgEl.src = src + (src.includes('?') ? '&' : '?') + 'width=200';
  }

  function quickAddRefreshState(){
    if (!quickAddModalBody) return;
    const variant = quickAddCurrentVariant();
    const priceEl = quickAddModalBody.querySelector('[data-quick-add-modal-price]');
    const submitBtn = quickAddModalBody.querySelector('[data-quick-add-modal-submit]');
    if (!priceEl || !submitBtn) return;
    quickAddUpdateImage();
    const textEl = submitBtn.querySelector('.confirm-btn-text') || submitBtn;
    if (variant) {
      priceEl.textContent = formatMoney(variant.price);
      submitBtn.disabled = !variant.available;
      textEl.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    } else {
      priceEl.textContent = '';
      submitBtn.disabled = true;
      textEl.textContent = 'Add to Bag';
    }
  }

  function buildQuickAddModalHtml(product){
    const optionsHtml = product.options.map((option, idx) => `
      <fieldset class="product-option" data-option-index="${idx}">
        <legend>${option.name}</legend>
        <div class="option-values">
          ${option.values.map((value, vIdx) => `
            <label>
              <input type="radio" name="quick-add-option-${idx}" value="${value.replace(/"/g,'&quot;')}"${vIdx === 0 ? ' checked' : ''}>
              <span>${value}</span>
            </label>
          `).join('')}
        </div>
      </fieldset>
    `).join('');

    return `
      <div class="quick-add-modal__product">
        ${product.image ? `<img data-quick-add-modal-image src="${product.image}" alt="" width="72" height="90">` : ''}
        <div>
          <h3>${product.title}</h3>
          <div class="price" data-quick-add-modal-price></div>
        </div>
      </div>
      ${optionsHtml}
      <div class="qty-stepper" data-quick-add-modal-qty>
        <button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>
        <span data-qty-value>1</span>
        <button type="button" data-qty-increase aria-label="Increase quantity">+</button>
      </div>
      <button type="button" class="btn btn--dark btn--full confirm-btn" data-quick-add-modal-submit>
        <span class="confirm-btn-label">
          ${quickAddModal?.dataset.logoUrl ? `<img src="${quickAddModal.dataset.logoUrl}" alt="" class="confirm-mark">` : ''}
          <span class="confirm-btn-text">Add to Bag</span>
        </span>
      </button>
      <p class="quick-add-modal__error" data-quick-add-modal-error></p>
    `;
  }

  function openQuickAddModal(product, wrap){
    if (!quickAddModal || !quickAddModalBody) return;
    quickAddProduct = product;
    quickAddSourceWrap = wrap;
    quickAddModalBody.innerHTML = buildQuickAddModalHtml(product);
    quickAddRefreshState();
    quickAddModal.classList.add('is-open');
    quickAddModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickAddModal(){
    if (!quickAddModal) return;
    quickAddModal.classList.remove('is-open');
    quickAddModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    quickAddProduct = null;
    quickAddSourceWrap = null;
  }

  document.addEventListener('click', e=>{
    const openBtn = e.target.closest('[data-quick-add-open]');
    if (!openBtn) return;
    e.preventDefault();
    const wrap = openBtn.closest('[data-quick-add]');
    const payloadEl = wrap?.parentElement.querySelector('[data-quick-add-payload]');
    if (!payloadEl) return;
    openQuickAddModal(JSON.parse(payloadEl.textContent), wrap);
  });

  document.addEventListener('click', e=>{
    if (quickAddModal?.classList.contains('is-open') && e.target.closest('[data-quick-add-close]')) {
      closeQuickAddModal();
    }
  });

  document.addEventListener('keydown', e=>{
    if (e.key === 'Escape' && quickAddModal?.classList.contains('is-open')) closeQuickAddModal();
    if (e.key === 'Escape' && searchOverlay?.classList.contains('is-open')) closeSearch();
    if (e.key === 'Escape') document.querySelectorAll('[data-mobile-nav-item].is-open').forEach(el=>el.classList.remove('is-open'));
  });

  // Listeners on the modal body are attached once (the body itself is a
  // stable, persistent element) and always act on the currently open product,
  // so re-opening the modal never accumulates duplicate handlers.
  quickAddModalBody?.addEventListener('change', e=>{
    if (e.target.matches('.option-values input')) quickAddRefreshState();
  });

  quickAddModalBody?.addEventListener('click', e=>{
    const stepBtn = e.target.closest('[data-quick-add-modal-qty] [data-qty-increase], [data-quick-add-modal-qty] [data-qty-decrease]');
    if (!stepBtn) return;
    e.preventDefault();
    const valueEl = quickAddModalBody.querySelector('[data-quick-add-modal-qty] [data-qty-value]');
    const current = parseInt(valueEl.textContent, 10) || 1;
    valueEl.textContent = stepBtn.matches('[data-qty-increase]') ? current + 1 : Math.max(1, current - 1);
  });

  quickAddModalBody?.addEventListener('click', async e=>{
    const submitBtn = e.target.closest('[data-quick-add-modal-submit]');
    if (!submitBtn || submitBtn.disabled) return;
    e.preventDefault();
    const variant = quickAddCurrentVariant();
    if (!variant) return;
    const qty = parseInt(quickAddModalBody.querySelector('[data-quick-add-modal-qty] [data-qty-value]').textContent, 10) || 1;
    submitBtn.disabled = true;
    const errorEl = quickAddModalBody.querySelector('[data-quick-add-modal-error]');
    errorEl.classList.remove('is-visible');
    try {
      const data = await quickAddToCart(variant.id, qty);
      updateCartCount(data.item_count);
      submitBtn.classList.add('is-added');
      setTimeout(()=>{
        submitBtn.classList.remove('is-added');
        closeQuickAddModal();
      }, 1800);
    } catch (err) {
      errorEl.textContent = err.message || 'Something went wrong.';
      errorEl.classList.add('is-visible');
      submitBtn.disabled = false;
    }
  });
})();

(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = el.dataset.revealDelay;
      if (delay) {
        el.style.transitionDelay = delay + 'ms';
      }
      el.classList.add('is-visible');
      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

  els.forEach(function (el) { io.observe(el); });
})();

(function () {
  // ?view=all on a collection page is inert to Shopify's own filtering —
  // it only marks that the "All" gender pill was explicitly picked, since
  // its href is otherwise a bare collection URL indistinguishable (server-
  // side) from a fresh landing that defaults to the collection's own
  // gender pre-checked.
  if (new URLSearchParams(location.search).get('view') !== 'all') return;
  const group = document.getElementById('GenderFilterGroup');
  if (!group) return;
  const pills = group.querySelectorAll('.filter-check--link');
  pills.forEach(function (a, i) { a.classList.toggle('is-active', i === 0); });
})();

(function () {
  const btn = document.getElementById('ThemeToggle');
  const flipInner = document.getElementById('ThemeToggleFlip');
  if (!btn) return;
  const root = document.documentElement;
  let themeColorMeta = document.getElementById('ThemeColorMeta');
  const STORAGE_KEY = 'ewoowe-theme';

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  function isDark() { return root.getAttribute('data-theme') === 'dark'; }

  function updateThemeColor(dark) {
    if (!themeColorMeta) return;
    // iOS Safari's status-bar tint only picks up a theme-color change that's
    // tied directly to the user gesture that caused it — replacing the
    // element (not just its content attribute) helps it register as a real
    // change, but it still has to happen in THIS synchronous call stack,
    // not deferred into the startViewTransition callback below (that runs
    // decoupled from the original click, which is late enough that Safari
    // stops treating it as gesture-driven and leaves the bar on the old color).
    const fresh = themeColorMeta.cloneNode(true);
    fresh.setAttribute('content', dark ? '#121110' : '#f8f6f1');
    themeColorMeta.replaceWith(fresh);
    themeColorMeta = fresh;
  }

  function sync() {
    const dark = isDark();
    btn.setAttribute('aria-pressed', String(dark));
    btn.setAttribute('aria-label', dark ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln');
  }
  sync();
  updateThemeColor(isDark());

  // Coin-flip: .theme-toggle__face--front (ink) and --back (cream) are
  // rotated 180deg apart and never re-shuffled — each click just adds
  // another 180deg to the running total, so backface-visibility always
  // shows whichever face matches the color the click just switched to,
  // without needing to snap/reset anything between flips.
  let flipDeg = 0;
  if (flipInner) {
    flipDeg = isDark() ? 180 : 0;
    flipInner.style.transform = 'rotateY(' + flipDeg + 'deg)';
  }

  function applyTheme(dark) {
    root.setAttribute('data-theme', dark ? 'dark' : 'light');
    try { localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light'); } catch (e) {}
    sync();
  }

  btn.addEventListener('click', function () {
    const dark = !isDark();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (flipInner) {
      flipDeg += 180;
      flipInner.style.transform = 'rotateY(' + flipDeg + 'deg)';
    }

    updateThemeColor(dark);

    // On iOS, document.startViewTransition's own screenshot-based crossfade
    // appears to be what blocks the status bar from re-tinting — even with
    // theme-color already updated above, before the transition starts. No
    // reload needed for this one: skipping the transition is enough on its
    // own. applyTheme() still runs — just one frame later — because setting
    // data-theme synchronously here forces the whole page's colors to
    // recalculate at the exact instant the flip animation starts, and that
    // recalc was winning the main thread and making the flip stutter. A
    // rAF lets the flip's first frame render uncontested; the (now CSS-
    // transitioned, see body{} in ewoowe.css) color swap follows right after.
    if (isIOS()) {
      requestAnimationFrame(function () { applyTheme(dark); });
      return;
    }

    // Page-wide fade reveal via the View Transitions API — browsers without
    // it (or reduced-motion users) just get the instant switch applyTheme
    // already does on its own.
    if (!reduceMotion && document.startViewTransition) {
      document.startViewTransition(function () { applyTheme(dark); });
    } else {
      applyTheme(dark);
    }
  });
})();

(function () {
  // Product 3D viewer — tag-gated, see main-product.liquid (product tagged
  // "3D-MODEL"). <model-viewer> (Google's web component, vendored at
  // assets/model-viewer.min.js — see data-mv-script below) is only fetched
  // and registered the first time a shopper actually opens the "360° View"
  // tab, so products without the tag, and shoppers who never click it, never
  // pay for it. On any failure (script blocked, GLB missing/corrupt) this
  // falls back to the plain product photo already sitting under it.
  const viewer = document.querySelector('[data-3d-viewer]');
  const tabs = document.querySelector('[data-view-tabs]');
  if (!viewer || !tabs) return;

  const stage = viewer.querySelector('[data-3d-stage]');
  const poster = viewer.querySelector('[data-3d-poster]');
  const gallery = document.querySelector('.product-gallery-grid');
  const glbSrc = viewer.dataset.glbSrc;
  const mvScript = viewer.dataset.mvScript;

  let modelViewerReady = null; // Promise, created lazily on first "3D" click

  function loadModelViewer() {
    if (modelViewerReady) return modelViewerReady;
    modelViewerReady = new Promise(function (resolve, reject) {
      if (customElements.get('model-viewer')) { resolve(); return; }
      const script = document.createElement('script');
      script.type = 'module';
      script.src = mvScript;
      script.onerror = function () { reject(new Error('model-viewer script failed to load')); };
      document.head.appendChild(script);
      customElements.whenDefined('model-viewer').then(resolve).catch(reject);
    });
    return modelViewerReady;
  }

  function showError() {
    stage.classList.remove('is-loading');
    stage.classList.add('has-error');
    const mv = stage.querySelector('model-viewer');
    if (mv) mv.remove();
  }

  function initModel() {
    if (stage.querySelector('model-viewer')) return; // already built
    stage.classList.add('is-loading');

    loadModelViewer().then(function () {
      const mv = document.createElement('model-viewer');
      mv.setAttribute('src', glbSrc);
      mv.setAttribute('alt', poster ? poster.getAttribute('alt') || '' : '');
      mv.setAttribute('camera-controls', '');
      mv.setAttribute('disable-pan', '');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('auto-rotate', '');
      mv.setAttribute('auto-rotate-delay', '2000');
      mv.setAttribute('rotation-per-second', '8deg');
      mv.setAttribute('exposure', '1');
      mv.setAttribute('shadow-intensity', '0.7');
      mv.setAttribute('shadow-softness', '0.9');

      mv.addEventListener('load', function () {
        stage.classList.remove('is-loading');
        stage.classList.add('is-loaded');
        // Radius as a % of model-viewer's own auto-framed distance, set only
        // once a model is actually loaded — this vendored build silently
        // aborts the whole load (no load/error/progress event at all) if
        // min/max-camera-orbit is present before then, since "auto" has
        // nothing to resolve against yet. Percentages (rather than a fixed
        // metre value) mean this keeps working unchanged once the real
        // hoodie.glb — almost certainly a different scale to this
        // placeholder — is dropped in: never lets the product shrink to
        // nothing or zoom in past the frame.
        mv.setAttribute('min-camera-orbit', 'auto 5deg 55%');
        mv.setAttribute('max-camera-orbit', 'auto 175deg 200%');
      });
      mv.addEventListener('error', showError);

      stage.appendChild(mv);
    }).catch(showError);
  }

  tabs.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-view-tab]');
    if (!btn) return;
    const target = btn.dataset.viewTab;

    tabs.querySelectorAll('[data-view-tab]').forEach(function (t) {
      const active = t === btn;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-pressed', String(active));
    });

    if (target === '3d') {
      if (gallery) gallery.hidden = true;
      viewer.hidden = false;
      initModel();
    } else {
      viewer.hidden = true;
      if (gallery) gallery.hidden = false;
    }
  });
})();

(function () {
  // First-visit welcome banner — shown once per browser, not once per
  // session, so a returning visitor a week later still won't see it again;
  // that's the point of gating on localStorage rather than sessionStorage.
  const banner = document.getElementById('WelcomeBanner');
  if (!banner) return;

  const STORAGE_KEY = 'ewoowe-welcome-seen';
  const TRANSITION_MS = 350;
  let closeTimer = null;

  function open() {
    const img = banner.querySelector('.welcome-banner__image');
    if (img && !img.src && img.dataset.src) img.src = img.dataset.src;
    banner.hidden = false;
    banner.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { banner.classList.add('is-open'); });
    });
  }

  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function close() {
    markSeen();
    banner.classList.remove('is-open');
    banner.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () { banner.hidden = true; }, TRANSITION_MS);
  }

  banner.addEventListener('click', function (e) {
    if (!e.target.closest('[data-welcome-close]')) return;
    if (e.target.closest('.welcome-banner__link')) { markSeen(); return; } // let the shop-now click through navigate
    e.preventDefault();
    close();
  });

  // Swipe-to-dismiss (mainly for mobile, but pointer events cover mouse
  // drag too for free). A quick flick counts even if the total distance is
  // short — that's why velocity, not just distance, can trigger it.
  const panel = banner.querySelector('.welcome-banner__panel');
  if (panel && window.PointerEvent) {
    const SWIPE_DISTANCE = 90;
    const SWIPE_VELOCITY = 0.5; // px/ms
    let dragging = false;
    let justSwiped = false;
    let startX = 0;
    let startTime = 0;
    let dragX = 0;

    function resetPanelStyle() {
      panel.style.transition = '';
      panel.style.transform = '';
      panel.style.opacity = '';
    }

    panel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startTime = Date.now();
      dragX = 0;
      panel.style.transition = 'none';
      try { panel.setPointerCapture(e.pointerId); } catch (err) {}
    });

    panel.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dragX = e.clientX - startX;
      panel.style.transform = 'translateX(' + dragX + 'px) rotate(' + (dragX / 40) + 'deg)';
      panel.style.opacity = String(Math.max(1 - Math.abs(dragX) / 400, .35));
    });

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      const elapsed = Math.max(Date.now() - startTime, 1);
      const velocity = Math.abs(dragX) / elapsed;
      panel.style.transition = 'transform .3s ease, opacity .3s ease';

      if (Math.abs(dragX) > SWIPE_DISTANCE || velocity > SWIPE_VELOCITY) {
        const dir = dragX < 0 ? -1 : 1;
        panel.style.transform = 'translateX(' + (dir * window.innerWidth) + 'px) rotate(' + (dir * 24) + 'deg)';
        panel.style.opacity = '0';
        justSwiped = true;
        close();
        setTimeout(resetPanelStyle, TRANSITION_MS + 60);
      } else {
        resetPanelStyle();
      }
    }

    panel.addEventListener('pointerup', onPointerUp);
    panel.addEventListener('pointercancel', onPointerUp);

    // A dragged-then-released mouse still fires a native click on whatever's
    // underneath afterward — without this, a swipe-dismiss could also
    // trigger the shop-now link's navigation on the way out.
    panel.addEventListener('click', function (e) {
      if (!justSwiped) return;
      justSwiped = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    // Mouse-only hover tilt: no depth data exists in a flat PNG, so this
    // isn't a real 3D reconstruction — it's a perspective-tilt-toward-the-
    // cursor trick (the same one many product/hero banners use) that reads
    // as "3D" without pretending to be more than it is. Skipped for touch
    // (no hover there — that's what the swipe gesture is for) and for
    // reduced-motion users.
    const img = banner.querySelector('.welcome-banner__image');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (img && !reduceMotion) {
      const MAX_TILT = 7; // degrees

      panel.addEventListener('pointermove', function (e) {
        if (dragging || e.pointerType !== 'mouse') return;
        const r = img.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        const rotateY = (px - .5) * MAX_TILT * 2;
        const rotateX = (.5 - py) * MAX_TILT * 2;
        img.style.transition = 'transform .1s linear';
        img.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale3d(1.015,1.015,1.015)';
      });

      panel.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        img.style.transition = 'transform .6s cubic-bezier(.2,.8,.2,1)';
        img.style.transform = '';
      });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && banner.classList.contains('is-open')) close();
  });

  // ?welcome=1 always shows it, seen or not — an easy way to re-test
  // without having to clear localStorage by hand each time.
  let forceShow = false;
  try { forceShow = new URLSearchParams(location.search).has('welcome'); } catch (e) {}

  let alreadySeen = false;
  try { alreadySeen = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

  if (forceShow || !alreadySeen) {
    setTimeout(open, 600);
  }
})();
